var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var THREE                    = require("three");

/**
 * @constructor
 */
var Plane3dMovementStateMachine = function (root, selectionModel) {
    var self = this;
    this.root = root;

    lib_core.StateMachine.call(this);

    self.contactObject = null;
    self.objectContactPosition = null;
    self.offset = null;
    self.hasPosition = false;
    this.selectionModel = selectionModel;

    this.movingKeyCodes = [];
    [ 'up', 'down', 'left', 'right'].forEach(function(value){
        self.movingKeyCodes.push(value);
        self.movingKeyCodes.push('S_' + value);
    }, self);

    this.timer = null;


    this.addTransition('idle', 'keyMoving',
        function (cEvent) {
            return (cEvent.isKeyPressed( self.movingKeyCodes) );
        },
        function (cEvent) {
            self.root.rec();
            self.keyMove(cEvent.data('keyCode'), cEvent);
            self.resetTimer();
        
        }
    );

    this.addTransition("keyMoving","keyMoving",
        function(cEvent) {
            return (cEvent.isKeyPressed( self.movingKeyCodes) );
        },
        function(cEvent) {
             self.keyMove(cEvent.data('keyCode'), cEvent);
             self.resetTimer();
        }
    );

    this.keyMovingStopTransition = this.addTransition("keyMoving", "idle",
        function(cEvent) {
            return (cEvent.type() == lib_core.GuiEvents.GUI_TIMER ||   // if timer ends or any other event (except for mouse_move or arrow keys) happens: end moving state
                    !(cEvent.isKeyPressed(self.movingKeyCodes) || cEvent.type().isHoverAction ));
        },
        function(cEvent){
             self.root.stopRec();
        }
    );

    this.addTransition("idle","moving",
        function(cEvent){
            // if element is moveable and EITHER not selectable or already selected 
            //      (if both selectable and movable selection comes first then trickles down)
            return (cEvent.type() == lib_core.GuiEvents.ELEMENT_MOUSE_DOWN
                    && cEvent.element() && cEvent.element().moveable 
                    && (cEvent.element().selected() || !cEvent.element().selectable) )
        },
        function(cEvent){
            var rayData = cEvent.data("ray");
            self.contactObject = cEvent.element();
            self.objectContactPosition = cEvent.data("mousePoint");
            var ray = new THREE.Ray(
                new THREE.Vector3(rayData.origin.x, rayData.origin.y, rayData.origin.z),
                new THREE.Vector3(rayData.direction.x, rayData.direction.y, rayData.direction.z)
            );

            self.root.rec();

            self.contactObject.createMovementPlane(ray, self.objectContactPosition);

            var intersection = new THREE.Vector3();
            if ( ray.intersectPlane( self.contactObject.movementPlane , intersection ) ) {

                self.contactObject.setContactPosition(intersection);
                var pos = self.contactObject.getPosition()
                if(pos){
                    self.hasPosition = true;
                    self.offset = new lib_geometry.Coord3d(
                        intersection.x - pos.x, 
                        intersection.y - pos.y, 
                        intersection.z - pos.z);
                }

            }
        }
    );

    this.addTransition("moving","moving",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.EDITOR_MOUSE_MOVE )
        },
        function(cEvent){
            var rayData = cEvent.data("ray");
            var ray = new THREE.Ray(
                new THREE.Vector3(rayData.origin.x, rayData.origin.y, rayData.origin.z),
                new THREE.Vector3(rayData.direction.x, rayData.direction.y, rayData.direction.z)
            );
 
            var intersection = new THREE.Vector3();
            if ( ray.intersectPlane( self.contactObject.movementPlane, intersection ) ) {

                    self.contactObject.setMousePosition(intersection);
                    if(self.hasPosition){   
                        self.contactObject.setOffsetPosition(
                            new lib_geometry.Coord3d(
                                intersection.x - self.offset.x, 
                                intersection.y - self.offset.y, 
                                intersection.z - self.offset.z
                            )
                        );
                    }

            } else {
                console.log("Plane 3d Movement -- no plane to move along");
            }
        }
    );


    this.addTransition("moving","idle",
        function(cEvent){
            return (cEvent.type() == lib_core.GuiEvents.CANVAS_MOUSE_UP);
        },
        function(cEvent){
            self.hasPosition = false;
            self.contactObject.released();
            self.root.stopRec();
        }
    );
};

lib_core.inherit(Plane3dMovementStateMachine, lib_core.StateMachine);


module.exports = Plane3dMovementStateMachine;

Plane3dMovementStateMachine.prototype.keyMove = function(keyCode, cEvent)
{
 
    var parts = keyCode.split("_");
    var shift = '';
    var direction = parts[0];
    if (parts.length == 2) {
        shift = parts[0];
        direction = parts[1];
    }

    var stepSize = this.getStepSize();
    if (shift == 'S') {
        stepSize /= 10;
    }

    var vector;
    switch(direction) {
        case 'up':
            vector = new lib_geometry.Coord(0, 1 * stepSize);
            break;
        case 'down':
            vector = new lib_geometry.Coord(0, -1 * stepSize);
            break;
        case 'left':
            vector = new lib_geometry.Coord(-1 * stepSize, 0);
            break;
        case 'right':
            vector = new lib_geometry.Coord(1 * stepSize, 0);
            break;
        default:
            return;
    }

    var keys = {altKey: cEvent.data('altKey'), shiftKey: cEvent.data('shiftKey')};
    if(!this.contactObject || !this.contactObject.getPosition()){
        // the contacted object is unknown.  this could be because
        // the contact object is a handle, something not selectable. (has not inhereted right stuff)
        // try and just move selection
        var selected = this.selectionModel.getInspectorSubjects();
        selected.forEach(function(selection){
            var pos = selection.getPosition();
            if(!pos) return; // give up
            selection.setOffsetPosition(
                new lib_geometry.Coord3d(
                    pos.x + vector.x,
                    pos.y + vector.y,
                    pos.z
                ), true
        )   ;
        });
    } else {
        var pos = this.contactObject.getPosition();
        // the contacted object is movable
        this.contactObject.setOffsetPosition(
            new lib_geometry.Coord3d(
                pos.x + vector.x,
                pos.y + vector.y,
                pos.z
            ), true
        );
    }
};

Plane3dMovementStateMachine.prototype.getStepSize = function()
{
    return 0.5;
};

Plane3dMovementStateMachine.prototype.resetTimer = function()
{
    if (this.timer) {
        window.clearTimeout(this.timer);
    }

    var self = this;
    this.timer = window.setTimeout(function(){
        self.handle(lib_core.GuiEvents.GUI_TIMER);
    }, 500);
};
